module.exports = __webpack_public_path__ + "img/Mohan_Kankanhalli@2x.19ef0a71.png";